import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createConfig, CreateConfigRequest, ConfigurationObject } from '../services/configs-api';

/**
 * TanStack Mutation hook for creating a new configuration object.
 * Invalidates the configs list cache on success.
 */
export function useCreateConfig() {
  const queryClient = useQueryClient();

  return useMutation<ConfigurationObject, Error, CreateConfigRequest>({
    mutationFn: (body) => createConfig(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['configs'] });
    },
  });
}
